import MultiEdit from './MultiEdit';

export default MultiEdit;
